import { Box, CircularProgress, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import TabsHeader from "./TabsHeader";
// import ParticipantProfile from "./ParticipantProfile";
// import { PanelItemsContainer, PanelWrapper } from "./ParticipantStyles";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import TabsContentSelector from "./TabsContentSelector";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
import { useParams, useSearchParams } from "react-router-dom";
import {
  setParticipantAssignable,
  setParticipantLocked,
} from "../../../Redux/reducers/participantTabSlice";
import { useQuery } from "../../../utils/hooks";
import MenuPanel from "./MenuPanel";
import { permissions } from "../../../utils/roles";
import { isParticipantLocked } from "../../../utils/participantLock";

const ParticipantTabs = () => {
  const type = useAppSelector((state) => state.participantTab.menuType);
  const dataEditable = useAppSelector((state) => state.study.dataEditable);
  const { id: studyId, participantId } = useParams();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);
  const tab = useQuery().get("tab");
  const participantQuery = useQuery().get("participant");
  let [, setSearchParams] = useSearchParams();
  const sitePermissions = useAppSelector(
    (state) => state.study.sitePermissions
  );

  useEffect(() => {
    if (tab) {
      sessionStorage.setItem("menu-type", tab);
      const params = new URLSearchParams();
      if (participantQuery) {
        params.set("participant", participantQuery);
      }
      setSearchParams(params, {
        replace: true,
      });
    }
  }, [tab, participantQuery]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setLoading(true);
        let url = `/participants/${participantId}?studyId=${studyId}`;
        const res = await http.get(url);
        const status = res?.data?.data?.eligibilityStatus;
        const locked = isParticipantLocked(res?.data?.data?.redactionStatus);
        const assignable =
          status === "included" &&
          dataEditable &&
          !locked &&
          sitePermissions?.[
            res?.data?.data?.site?.id || ""
          ]?.permissions?.includes(permissions.editParticipant);
        dispatch(setParticipantAssignable(assignable));
        dispatch(setParticipantLocked(locked));
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchDetails();
    return () => {
      sessionStorage.removeItem("menu-type");
      dispatch(setParticipantAssignable(false));
      dispatch(setParticipantLocked(false));
    };
  }, [dispatch, participantId, studyId, dataEditable, sitePermissions]);

  return loading ? (
    <Stack
      sx={{
        flex: 1,
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress color="primary" />
    </Stack>
  ) : (
    <>
      <TabsHeader setShowDownloadModal={setShowDownloadModal} />
      <Stack
        direction="row"
        sx={{
          height: "calc(100% - 80px)",
        }}
      >
        {/* <Box sx={PanelWrapper}>
          <Stack gap={1} sx={PanelItemsContainer}>
            <ParticipantProfile />
          </Stack>
        </Box> */}
        <MenuPanel />
        <Box sx={{ flex: 1, height: "100%" }}>
          {type && (
            <TabsContentSelector
              showDownloadModal={showDownloadModal}
              setShowDownloadModal={setShowDownloadModal}
            />
          )}
        </Box>
      </Stack>
    </>
  );
};

export default ParticipantTabs;
